import { Icon } from 'ant-design-vue';

const BaseIcon = Icon.createFromIconfontCN({
  scriptUrl: '../iconfont/iconfont.js'
  // scriptUrl: '//at.alicdn.com/t/font_1748773_k3ywmvlf1yf.js' // 仅开发时使用，项目完成的时候需要下载到本地
});
export default BaseIcon;
